import { navigate } from 'gatsby';
import React, { FC } from 'react';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';
import TextLink, { ITextLinkProps } from '@ui/atoms/TextLink';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import aligned from '@ui/styled/Aligned';

import { commonLabels } from '@utils/button';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

export interface IMemberAdhdInstructionsStepPageContent {
	noDiagnosisPageHeader: string;
	noDiagnosisPageInfo: string;
	noDiagnosisInstructionsLabel: string;
	noDiagnosisInstructionsLink: string;

	hasDiagnosisPageHeader: string;
	hasDiagnosisPageInfo: string;
	hasDiagnosisInstructionsLabel: string;
	hasDiagnosisInstructionsLink: string;
	hasDiagnosisDisclaimer: string;
}

interface IMemberAdhdInstructionsStepProps extends IFlowStepComponentProps {
	pageContent: IMemberAdhdInstructionsStepPageContent;
	hasAdhdDiagnosis?: boolean;
}

const AlignedLink = aligned<ITextLinkProps>(TextLink);

const MemberAdhdInstructionsStep: FC<IMemberAdhdInstructionsStepProps> = ({
	pageContent,
	handleNavNext = () => {
		return;
	},
	hasAdhdDiagnosis = false,
	stepKey,
}) => {
	const {
		noDiagnosisPageHeader,
		noDiagnosisPageInfo,
		noDiagnosisInstructionsLabel,
		noDiagnosisInstructionsLink,

		hasDiagnosisPageHeader,
		hasDiagnosisPageInfo,
		hasDiagnosisInstructionsLabel,
		hasDiagnosisInstructionsLink,
		hasDiagnosisDisclaimer,
	} = pageContent;

	return (
		<CenteredGridItem>
			<FlexColumn fullWidth gap="lg">
				<SubheadingText>
					{hasAdhdDiagnosis ? hasDiagnosisPageHeader : noDiagnosisPageHeader}
				</SubheadingText>
				<WYSIWYGContent
					dangerouslySetInnerHTML={{
						__html: hasAdhdDiagnosis ? hasDiagnosisPageInfo : noDiagnosisPageInfo,
					}}
				/>
				<AlignedLink
					newTab
					alignSelf="center"
					mobileSize="xs"
					desktopSize="sm"
					label={hasAdhdDiagnosis ? hasDiagnosisInstructionsLabel : noDiagnosisInstructionsLabel}
					href={hasAdhdDiagnosis ? hasDiagnosisInstructionsLink : noDiagnosisInstructionsLink}
				/>
				{!!hasAdhdDiagnosis && <BasicText>{hasDiagnosisDisclaimer}</BasicText>}
				<Button
					variant="secondary"
					label={hasAdhdDiagnosis ? commonLabels.okay : commonLabels.account}
					onClick={() => {
						if (hasAdhdDiagnosis) {
							handleNavNext(stepKey);
						} else {
							navigate('/app/member');
						}
					}}
				/>
			</FlexColumn>
		</CenteredGridItem>
	);
};

export default MemberAdhdInstructionsStep;
